import { QueryKey, useIsFetching, useIsMutating } from '@tanstack/react-query'

// usage:
// const isCartLoading = useGlobalLoading({ queryKey: ['cart'] })
// const isProductLoading = useGlobalLoading({ queryKey: ['products', { id: 123 }] })

type UseGlobalLoadingParams = {
  queryKey?: QueryKey
}

export const useGlobalLoading = ({ queryKey }: UseGlobalLoadingParams = {}) => {
  const fetchCount = useIsFetching({ queryKey })
  const mutateCount = useIsMutating({ mutationKey: queryKey })

  return fetchCount > 0 || mutateCount > 0
}
